module.exports = __webpack_public_path__ + "img/mapUnActive.746401db.png";